import { Image } from "@/components/image";
import { contributorLogo } from "@/lib/contributor-profile";
import type { ProfileField } from "@/lib/contributor-profile";
import { cn } from "@/lib/utils";

export function ContributorAvatar({
  fields,
  name,
  className,
}: {
  fields: ProfileField[];
  name: string;
  className?: string;
}) {
  const logo = contributorLogo(fields);
  return (
    <span
      aria-hidden
      className={cn(
        "flex size-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-muted text-lg font-medium",
        className
      )}
    >
      {logo ? (
        <Image
          alt=""
          className="size-full object-contain p-1"
          height={96}
          width={96}
          src={logo}
        />
      ) : (
        name
          .trim()
          .split(/\s+/u)
          .map((part) => part[0])
          .slice(0, 2)
          .join("")
      )}
    </span>
  );
}
